const accountI18n = require('./account')
module.exports = {
  // title
  ...accountI18n,
  store: 'Store',
  merchant: 'Merchant',
  storeManager: 'Store Management',
  businessManager: 'Business Management',
  imageManager: 'Image Management',
  infoManager: 'Information Management',
  financeManager: 'Finance Management',
  orderManager: 'Order Management',
  historyOrder: 'History Order',
  allOrder: 'All Orders',
  addExtraTime: 'Add extraTime',
  preOrder: 'New Orders',
  appointmentOrder: 'Booking',
  mealPreOrder: 'Preparing',
  mealFinish: 'Prepared',
  refundOrder: 'Cancellation/Refund',
  itemManager: 'Item Management',
  classfication: 'Category List', // dump
  itemList: 'Item List',
  open: 'Open',
  rest: 'Resting',
  pushMessage: 'Push Message',
  labelOptions: 'label Options',
  labelCloseOther: 'close Other',
  labelCloseAll: 'close All',
  openShop: 'Start Business',
  notSupport: 'not support',
  within1: 'within the day',
  within2: 'within 2 days',
  within3: 'within 3 days',
  within4: 'within 4 days',
  within5: 'within 5 days',
  merchantName: 'Merchant Name',
  showMap: 'Show Map',
  menuSetting: 'Menu Settings',
  addMenu: 'add Menu',
  storeName: 'Store Name',
  contactName: 'Contact Name',
  contactTel: 'Contact Phone',
  ownedCity: 'City',
  coordinate: 'Store Coordinate',
  longitude: 'Longitude',
  latitude: 'Latitude',
  storeAddress: 'Store Address',
  plan: 'Display Image',
  envPhoto: 'Environment Image',
  storeStatus: 'Store Status',
  openDate: 'Start Business Time',
  businessStatus: 'Business Status',
  businessDay: 'Business Day',
  businessTime: 'Business Time',
  paymentMethod: 'Payment Method',
  mainBusiness: 'Main Business',
  businessRange: 'Business Scope',
  businessType: 'Business Type',
  preMealTime: 'Meal preparation time',
  valueAddTax: 'VAT Rate',
  bookingTime: 'Booking Time',
  startPrice: 'Starting Price',
  speedService: 'Fastest Service',
  basicTime: 'Basic Meal Preparation Time',
  bigTime: 'Large Meal Preparation Time',
  useActuallyPay: 'When Customer Payment',
  hour: '$',
  openExpress: 'open',
  closeExpress: 'close',
  today: 'Today',
  tomorrow: 'Tomorrow',
  asOf: 'Until',
  newStoreLabel: 'New Store Label',
  newStore: 'new Store',
  noNewStore: 'Non-new Store',
  switchBusinessStatus: 'Switch business status to closed, Are you sure?',
  sureOpenBusiness: 'Are you sure to opened, can not be modified after opening?',
  accountName: 'Account Name',
  accountBank: 'Account Bank',
  bankAccount: 'Bank Account',
  serviceCalc: 'Service Fee Calculation Method',
  serviceRate: 'Service Rate',
  minAmount: 'Min withdrawal Amount',
  remainingBalance: 'Remaining Balance',
  WithdrawalMethod: 'Withdrawal Method',
  startDate: 'Start Date',
  withdrawalCycle: 'Withdrawal Cycle',
  day: 'Day',
  handApplyWithdrawal: 'Manually Apply For Withdrawal',
  autoApplayWithdrawal: 'Automatic Withdrawal Application',
  nextWithdrawal: 'Next Automatic Withdrawal Date',
  noHandApplyWithdrawal: 'Unable to process manually apply for withdrawal',
  deleteCategory: 'This operation will permanently delete this category. Do you want to continue ?',
  autoRest: 'Will automatically rest at {args}',
  autoBusiness: 'Will automatically open at {args}',
  noAuto: 'Will not automatically open / rest, need to manually open / rest',
  search_map: 'Please enter the address query',
  storeClosed: 'Store is closed',
  storeStopTime: 'Suspend Business Plan',
  endTimeShouldNotGtStartTime: 'The start time of suspend business plan must bigger then the end time',
  maxsixtyDay: "The maximum time interval for the suspension of business can be set to 60 days",
  stopStoreBusiness: 'The store is temporarily closed. Switching the status at this time will abandon the store suspension plan.',
  startTimeLimit: 'Start time must not be less than current time',
  businessTimeLimit: 'Business start time and business end time cannot be the same',
  vatCaclMethod: 'VAT calculation method',
  packageAmount: 'Packing fee',
  packageAmountTips: 'Setting the package fee will affect the user\'s order',
  every: 'every',
  caclByMainScope: 'Calculate by store\'s main business',
  editMenu: 'Edit Menu',
  editStock: 'Edit Stock',
  stockMust: 'stock must >=0',
  stockMax: 'Cannot exceed the maximum stock',
  intCheck: 'Please enter an integer',
  noMenu: 'no menu',
  CalculatedMethod: 'Calculated as [Item Original Price + Packaging Fee + VAT]',
  announcement: 'Announcement',
  announcementTime: 'Announcement end time',
  largePrepareTimeTip: "Every ${x} will wait",
  maxMealTimeTip:"// Order amount >= ${maxmoney}, will use maximum preparing time",
  factor: 'Factor',
  maxPrepareTime: 'Maximum Preparing Time',
  submitFail:'Submit Fail',
  submitFailTip:'Dear WOWNOW partners,​​  system has detected your business status has been abnormal recently, because of your  automatically resting. If you need to resume business, please contact platform consultant.',
  tooShortBusinessHourTitle: 'Store Business Hour Too Short',
  tooShortBusinessHourTip: 'Store Business Hour Setting Too Short, Do you want to continue sumitting? '
}
